function words(name: string): string[] {
  return name.trim().split(/\s+/).filter(Boolean);
}

/** Primeiro e último nome, para caber em uma linha; o nome completo fica na dica e no painel. */
export function personShortName(name: string): string {
  const parts = words(name);
  return parts.length > 2 ? `${parts[0]} ${parts[parts.length - 1]}` : parts.join(' ');
}

/** Iniciais do primeiro e do último nome, em maiúsculas. */
export function personInitials(name: string): string {
  const letters = words(name).flatMap((word) => word.match(/\p{L}/u)?.[0] ?? []);
  const last = letters.length > 1 ? letters[letters.length - 1] : '';
  return `${letters[0] ?? ''}${last}`.toUpperCase();
}
